import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import AnalyticDetailsLayout from '../../components/analytics-details-v2/AnalyticDetailsLayout'
import { buildRelativePath, PathConfig } from '../../core/config/PathConfig'
import NewChroniqueur from '../../components/chroniqueur/new-chronique-view/NewChroniqueur'
import AnalyticsDialogExit from '../../components/share/dialog/AnalyticsDialogExit'
import { CreateChroniqueurResponse } from '../../core/interface/chronique.interface'
import { BookInterface } from '../../core/interface/book.interface'
import AudiencePreValidatedSummary from '../../components/chroniqueur/new-chronique-view/AudiencePreValidatedSummary'

const NewChroniqueurView = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [audienceName, setAudienceName] = useState<string>(
    t('chroniqueurView.defaultTitle', { date: dayjs().format('DD/MM/YYYY') }),
  )
  const [exitDialog, setExitDialog] = useState<boolean>(false)
  const [audiencePreValidated, setAudiencePreValidated] =
    useState<boolean>(false)
  const [booksSelected, setBooksSelected] = useState<BookInterface[]>([])
  const [createChroniqueurResponse, setCreateChroniqueurResponse] =
    useState<CreateChroniqueurResponse | null>(null)

  const backToPrivateReports = useCallback(() => {
    navigate(
      buildRelativePath([PathConfig.BOOKMETRIE, PathConfig.PRIVATE_REPORTS]),
    )
  }, [])

  const closeDialog = useCallback(() => {
    setExitDialog(false)
  }, [])

  return (
    <>
      <AnalyticDetailsLayout
        analyticName={audienceName}
        handleRenameAnalytic={setAudienceName}
        handleExitAnalyticDetails={() => setExitDialog(true)}
        isLoading={false}
        hasButtonPrevious={false}
      >
        {audiencePreValidated && createChroniqueurResponse ? (
          <AudiencePreValidatedSummary
            selectedUsersSummary={createChroniqueurResponse}
            bookSelected={booksSelected}
          />
        ) : (
          <NewChroniqueur
            title={audienceName}
            onValidatePreSelectedAudience={() => setAudiencePreValidated(true)}
            booksSelected={booksSelected}
            setBooksSelected={setBooksSelected}
            setCreateChroniqueurResponse={setCreateChroniqueurResponse}
          />
        )}
      </AnalyticDetailsLayout>
      <AnalyticsDialogExit
        open={exitDialog}
        onValidate={backToPrivateReports}
        onClose={closeDialog}
      />
    </>
  )
}

export default NewChroniqueurView
